import React, { Component } from "react";
import PropTypes from "prop-types";

class FilterSubSection extends Component {
    static propTypes = {
        children: PropTypes.node,
        heading: PropTypes.string.isRequired
    };

    state = {
        active: false
    };

    handleClick = () => {
        this.setState({ active: !this.state.active });
    }

    render() {
        const { children, heading } = this.props;
        const { active } = this.state;

        return (
            <div className={`filter-sub-section ${active ? "is-accordion-active" : ""}`}>
                <div className="filter-sub-section__heading" onClick={this.handleClick}>
                    {heading}
                    <div className="filter-sub-section__icon"></div>
                </div>
                <div className="filter-sub-section__collapse">{children}</div>
            </div>
        );
    }
}

export default FilterSubSection;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/FilterSubSection.js